<template>
    <div :style="cssProps">
        <base-header type="gradient-info" class="pb-6 pb-8 pt-5 pt-md-8">
            <div class="row mb-2">
                <div class="col">
                    <h1 class="text-white pt-3 px-3">月度回执</h1>
                    <p class="text-white pb-3 px-3">*请在当月最后一天之前检查信息和税务发票地址的准确性。
                        当系统已开具税务发票时,以后将无法编辑税务发票信.*
                    </p>
                </div>
            </div>
        </base-header>
        <div class="text-center" v-if="busy">
            <BlockUI>
                <div class="loader"></div>
            </BlockUI>
        </div>
        <div class="container-fluid mt--8 mb-5">
            <div class="row">
                <div class="col">
                    <div class="card shadow py-5">
                        <div class="col-lg-12">
                            <b-table
                                ref="reportDelivery"
                                show-empty
                                responsive
                                :items="dataList"
                                :fields="fields"
                                :per-page="search.pageSize"
                                :busy="busy"
                                selectable
                                select-mode="multi"
                                class="scroll-bar-pop text-center"
                                empty-text="ไม่มีข้อมูลผู้ใช้"
                                empty-filtered-text="ไม่พบข้อมูลที่ต้องการค้นหา"
                            >
                                <template slot="month" slot-scope="data">
                                    <span
                                        v-if="data.item.recordType !== 1">{{ data.item.year }}-{{
                                            data.item.month
                                        }}</span>
                                    <span v-if="data.item.recordType === 1">{{ data.item.outOfAccountTime }}</span>
                                </template>
                                <template slot="isCorrect" slot-scope="data">
                                    <el-tag size="mini" type="success"
                                            v-if="data.item.isCorrect && data.item.recordType === 1">是
                                    </el-tag>
                                    <el-tag size="mini" type="danger"
                                            v-if="!data.item.isCorrect && data.item.recordType === 1">否
                                    </el-tag>
                                    <span v-if="data.item.recordType !== 1">-</span>
                                </template>
                                <template slot="CoorrectResult" slot-scope="data">
                                    <el-tag size="mini" type="success"
                                            v-if="data.item.financialStatus && data.item.recordType === 1">通过
                                    </el-tag>
                                    <el-tag size="mini" type="danger"
                                            v-if="!data.item.financialStatus && data.item.recordType === 1">审验中
                                    </el-tag>
                                    <span v-if="data.item.recordType !== 1">-</span>
                                </template>
                                <template slot="operate" slot-scope="data">
                                    <b-button v-if="data.item.recordType === 1" variant="success"
                                              @click="downloadDetail(data.item.path)">下载明细
                                    </b-button>
                                    <b-button variant="primary" size="sm" v-if="data.item.recordType === 1 && !data.item.isCorrect" @click="fnCorrectInfo(data.item.id)">查核</b-button>
                                    <b-button variant="warning" size="sm" v-if="data.item.recordType === 1 && data.item.financialStatus && data.item.isCorrect" @click="fnGetSettlementInvoice(data.item.outOfAccountTime)">下载回执</b-button>
                                    <b-button size="sm" variant="success" v-if="data.item.recordType !== 1"  @click="handleDetailList(data.item)">详情</b-button>
                                    <b-button v-if="data.item.recordType !== 1 && data.item.isDayInvoice =='0'" size="mini" type="success" @click="downloadNewDetail(data.item)">下载明细</b-button>
                                    <b-button v-if="data.item.recordType !== 1 && data.item.isDayInvoice =='0'&&(data.item.year < 2023 || (data.item.year === 2023 && data.item.month <= 6))" size="mini" type="warning" @click="downloadNewReceipt(data.item)">下载回执</b-button>
                                </template>
                            </b-table>
                            <div class="mt-3">
                                <b-pagination
                                    :total-rows="totalItem"
                                    :current-page="search.pageIndex"
                                    :per-page="search.pageSize"
                                    :value="search.pageIndex"
                                    @input="changePage"
                                    align="right">
                                </b-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <b-modal
            centered
            hide-footer
            v-model="correctInfoOptions.visible"
            size="lg"
            title="查核"
            @hide="closeCheckModal"
        >
            <p style="color: red;font-weight: bold">请确认扣款明细是否正确，信息无误将会生成发票</p>
            <b-form @submit="correctInfoSubmit">
                <b-form-group
                    id="input-group-1"
                    label="是否正确:"
                    label-for="input-1"
                >
                    <b-form-radio-group
                        required
                        @change="onChangeRadio"
                        id="radio-group-1"
                        v-model="auditFrom.isCorrect"
                        :options="options"
                        name="radio-options"
                    ></b-form-radio-group>
                </b-form-group>
                <b-form-group
                    v-if="this.auditFrom.isCorrect==0"
                    id="input-group-1"
                    label="错误原因"
                    label-for="input-1"
                >
                    <b-form-input
                        id="input-1"
                        v-model="auditFrom.feedBackRemark"
                        placeholder="请输入错误原因"
                        required
                    ></b-form-input>
                </b-form-group>
                <b-form-group
                    v-if="this.auditFrom.isCorrect==0"
                    id="input-group-1"
                    label="附件"
                    label-for="input-1"
                >
                    <b-form-file
                        required
                        v-model="file1"
                        @change="onFileChange"
                        placeholder="Choose a file or drop it here..."
                        drop-placeholder="Drop file here..."
                    ></b-form-file>
                </b-form-group>
                <div class="d-flex justify-content-center mt-4">
                    <b-button
                        class="px-5"
                        type="submit"
                        variant="primary"
                    >
                        提 交
                    </b-button>
                </div>
            </b-form>
        </b-modal>
    </div>
</template>
<script>

import {hexToRgbA} from "@/plugins/hexColor";
import {agentBillInvoiceList, appealSettlement, getSettlementInvoice, getTaxInfo} from "@/api/monthReceipt";
import {uploadFile} from "@/api/storeManage";

export default {
    name: "MonthReceipt",
    data() {
        return {
            file1: null,
            auditFrom: {
                isCorrect: 1,
                feedBackRemark: '',
                feedBackAttachment: ''
            },
            selected: null,
            options: [
                {text: '信息正确', value: 1},
                {text: '信息有误', value: 0},
            ],
            totalItem: 0,
            busy: false,
            dataList: [],
            fields: [
                {key: "month", label: "月份", sortable: false, class: "text-center"},
                {key: "freightCount", label: "单量", sortable: false, class: "text-center"},
                {key: "totalFee", label: "支付费用", sortable: false, class: "text-center"},
                {key: "isCorrect", label: "是否查核", sortable: false, class: "text-center"},
                {key: "CoorrectResult", label: "审验结果", sortable: false, class: "text-center"},
                {key: "operate", label: "操作", sortable: false, class: "text-center"},
            ],
            search: {
                pageIndex: 1,
                pageSize: 10,
            },
            correctInfoOptions: {
                visible: false,
                ReceiptInfo: {}
            }
        }
    },
    created() {

    },
    mounted() {
        this.agentBillInvoiceList()
    },
    methods: {
        downloadNewReceipt(row) {
            if (row.agentInvoiceUrl == "") {
                this.$message.error(this.$t('Mortgage.noReceipt'))
            } else {
                window.open(row.agentInvoiceUrl)
            }
        },
        downloadNewDetail(row) {
            if (row.agentExcelUrl == "") {
                this.$message.error(this.$t('Mortgage.noDetail'))
            } else {
                window.open(row.agentExcelUrl)
            }
        },
        handleDetailList(row) {
            console.log(row);
            let month = row.year + '-' + row.month + '-01' + " 00:00:00"
            let type = row.isDayInvoice
            this.$router.push({path: 'receiptDetailList', query: {month: month, type: type}}
            )
        },
        //下载回执
        async fnGetSettlementInvoice(row) {
            if (row) {
                let res = await getSettlementInvoice({
                    month: row
                })
                window.open(res.data)
                this.agentBillInvoiceList()
            }
        },
        onChangeRadio(e) {
            console.log(e)
            this.auditFrom.feedBackRemark = ''
            this.auditFrom.feedBackAttachment = ''
            this.file1 = null
        },
        onFileChange(e) {
            this.file1 = e.target.files[0]
            console.log(this.file1)
            const formData = new FormData();
            formData.append('file', this.file1);

            uploadFile(formData).then(res => {
                console.log(res.data.fileUrl)
                this.auditFrom.feedBackAttachment = res.data.fileUrl
            }).catch(err => {
                console.log(err);
            })
        },
        correctInfoSubmit(evt) {
            evt.preventDefault()
            console.log('correctInfoSubmit', this.correctInfoOptions.ReceiptInfo)
            appealSettlement({
                id: this.correctInfoOptions.ReceiptInfo,
                ...this.auditFrom
            }).then(res => {
                this.agentBillInvoiceList()
                this.correctInfoOptions.visible = false
                this.auditFrom = {
                    isCorrect: 1,
                    feedBackRemark: '',
                    feedBackAttachment: ''
                }
            }).catch(err => {
                console.log(err);
            })
        },
        closeCheckModal() {
            this.correctInfoOptions.visible = false
        },
        fnCorrectInfo(row) {
            this.fnGetTaxAddressInfo()
            this.correctInfoOptions.visible = true
            this.correctInfoOptions.ReceiptInfo = row
        },
        fnGetTaxAddressInfo() {
            getTaxInfo({
                type: 1
            })
                .then((res) => {
                    this.correctInfoOptions.taxAddressInfo = res.data
                })
        },
        downloadDetail(row) {
            window.open(row, '_blank')
        },
        changePage(i) {
            if (this.search.pageIndex == i) return;
            this.search.pageIndex = i
            this.agentBillInvoiceList()
        },
        agentBillInvoiceList() {
            this.busy = true;
            agentBillInvoiceList({
                month: '',
                ...this.search
            })
                .then((res) => {
                    this.busy = false;
                    this.dataList = res.data.data;
                    this.totalItem = res.data.total;
                }).finally(() => {
                this.busy = false;
            })
        }
    },
    computed: {
        cssProps() {
            return {
                '--bg-hover-color': hexToRgbA('#11cdef', 0.7),
                '--bg-color': '#11cdef',
            }
        }
    }
};
</script>
<style scoped>

</style>
